// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-pahoittelu[data-v-419c1efd] {\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  -webkit-transform: translate(calc(50vw - 50%), calc(50vh - 50%));\n          transform: translate(calc(50vw - 50%), calc(50vh - 50%));\n}", ""]);
// Exports
module.exports = exports;
